import React from 'react';
import './src/styles/global.css';

import RootElement from './src/components/root-elemente';
import RootLayout from './src/components/layout';

export const wrapPageElement = ({ element }) => {
  return (
    <RootElement>
      <RootLayout>{element}</RootLayout>;
    </RootElement>
  );
};
